/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Outbound/view.blocks to change it.
import Attachments from './Attachments/index'
import CardMessageNoAvatar from 'DesignSystem/CardMessageNoAvatar/index'
import Content from './Content/index'
import Info from './Info/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Outbound({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/EventsTimeline/Content/Event/Types/Sms/Content/Outbound"
  
}) {
  return (<React.Fragment
>
<CardMessageNoAvatar
  viewPath={`${viewPath}/CardMessageNoAvatar`}
 marginLeft={30}
 alignSelf="flex-end"
 backgroundColor="rgba(0,0,0,0.02)"
>
{childProps => (
<React.Fragment>
<Content
{...childProps}
  viewPath={`${viewPath}/Content`}
/>
<Info
{...childProps}
  viewPath={`${viewPath}/Info`}
/>
<Attachments
{...childProps}
  viewPath={`${viewPath}/Attachments`}
/>
</React.Fragment>
)}
</CardMessageNoAvatar>
{children}
</React.Fragment>)
}